import { supabase, TABLES } from "../lib/supabase";

export interface Commission {
  id: number;
  contract_type_id: number;
  commission_level_id: number;
  comission: number;
  valid_from: string;
  valid_to: string | null;
  level_description?: string;
  level_number?: number;
}

export async function getCommissionsByContractType(
  contractTypeId: number
): Promise<Commission[]> {
  const { data, error } = await supabase
    .from(TABLES.COMISSIONS)
    .select(
      `
      *,
      commission_levels:commission_level_id (
        level_number,
        description
      )
    `
    )
    .eq("contract_type_id", contractTypeId);

  if (error) {
    console.error("Error fetching commissions:", error);
    return [];
  }

  return data.map((item: any) => ({
    ...item,
    level_description: item.commission_levels?.description,
    level_number: item.commission_levels?.level_number,
  }));
}

export async function updateCommission(
  id: number,
  data: Partial<Commission>
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase
      .from(TABLES.COMISSIONS)
      .update({
        comission: data.comission,
        valid_from: data.valid_from,
        valid_to: data.valid_to,
        commission_level_id: data.commission_level_id,
      })
      .eq("id", id);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error("Error updating commission:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
}

export interface CreateCommissionData {
  contract_type_id: number;
  commission_level_id: number;
  comission: number;
  valid_from: string;
  valid_to?: string | null;
}

export async function createCommission(
  data: CreateCommissionData
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase.from(TABLES.COMISSIONS).insert([data]);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error("Error creating commission:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
}

export async function deleteCommission(
  id: number
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase
      .from(TABLES.COMISSIONS)
      .delete()
      .eq("id", id);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error("Error deleting commission:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
}

